import PushMagazine from './pushMagazine'

const pushMagazine = new PushMagazine()
pushMagazine.init()
